import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./calcite-input.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./calcite-input.component.css?ngResource";
import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { UntypedFormBuilder, NG_VALUE_ACCESSOR } from "@angular/forms";
let CalciteInputComponent = class CalciteInputComponent {
    formBuilder;
    changeDetectorRef;
    addClearInputBtn = false;
    type = "text" /* CalciteInputTypeEnum.text */;
    disable = false;
    groupSeparator = false;
    maxLength = 100;
    placeholder = "";
    inputLabelText = "";
    required = false;
    requiredText = "*";
    requiredClass = "calcite-input-text-danger";
    // test
    // upon UI element value changes, this method gets triggered
    val;
    inputForm;
    constructor(formBuilder, changeDetectorRef) {
        this.formBuilder = formBuilder;
        this.changeDetectorRef = changeDetectorRef;
        // upon touching the element, this method gets triggered
        this.inputForm = this.formBuilder.group({
            calciteFormControl: []
        });
    }
    get value() {
        return this.inputForm?.value;
    }
    set value(val) {
        this.inputForm?.get("calciteFormControl")?.patchValue(val);
        this.val = val;
        this.onChange(val);
        this.onTouch(val);
    }
    ngOnInit() {
        this.initialiseForm();
    }
    onChange = () => {
    };
    onTouch = () => {
    };
    // this method sets the value programmatically
    writeValue(value) {
        this.value = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    initialiseForm() {
        this.inputForm = this.formBuilder.group({
            calciteFormControl: []
        });
    }
    static ctorParameters = () => [
        { type: UntypedFormBuilder },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        addClearInputBtn: [{ type: Input }],
        type: [{ type: Input }],
        disable: [{ type: Input }],
        groupSeparator: [{ type: Input }],
        maxLength: [{ type: Input }],
        placeholder: [{ type: Input }],
        inputLabelText: [{ type: Input }],
        required: [{ type: Input }],
        requiredText: [{ type: Input }],
        requiredClass: [{ type: Input }]
    };
};
CalciteInputComponent = __decorate([
    Component({
        selector: 'lib-calcite-input',
        template: __NG_CLI_RESOURCE__0,
        providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CalciteInputComponent),
                multi: true
            }
        ],
        styles: [__NG_CLI_RESOURCE__1]
    })
], CalciteInputComponent);
export { CalciteInputComponent };
